export type ReverseSourceType =
  | 'payment-request'
  | 'factoring-request'
  | 'confirming-request'
  | 'credit-request'
  | 'payment-request-passive';

export const REVERSE_PERMISSIONS_MAP: Record<ReverseSourceType, string> = {
  'payment-request': 'reverse_payouts_payment_request',
  'factoring-request': 'reverse_payouts_factoring_request',
  'confirming-request': 'reverse_payouts_confirming_request',
  'credit-request': 'reverse_payouts_credit_request',
  'payment-request-passive': 'reverse_payouts_payment_request_passive',
};

export const IMPLEMENTED_REVERSE_SOURCES: ReverseSourceType[] = [
  'payment-request',
];

export const getReversePermission = (source: string): string | null => {
  return REVERSE_PERMISSIONS_MAP[source as ReverseSourceType] || null;
};

export const canReverseSource = (source: string): boolean => {
  return IMPLEMENTED_REVERSE_SOURCES.includes(source as ReverseSourceType);
};
